export default "__VITE_ASSET__6iROLoXw__"